import * as Sentry from '@sentry/browser';
import { Integrations as ApmIntegrations } from '@sentry/apm';

import UAParser from 'ua-parser-js';

import createMap from './createMap';
import './main.scss';

// Build-defined constants
const sentryUrl = process.env.VUE_APP_SENTRY_URL;
const authHost = process.env.VUE_APP_AUTH_HOST;

Sentry.init({
  dsn: sentryUrl,
  environment: process.env.NODE_ENV,
  debug: process.env.NODE_ENV === 'development',
  integrations: [
    new ApmIntegrations.Tracing(),
  ],
  // TODO: possibly revisit, this isn't intended to track every request, we just
  // happen to have a small enough number of students that we can do this.
  tracesSampleRate: 1.0,
});

const transactionId = Math.random().toString(36).substr(2, 9);
Sentry.configureScope((scope) => {
  scope.setTag('pearson_ua', /Lock_(win|mac)/.test(new UAParser().getUA()) ? 'yes' : 'no');
  scope.setTag('vdp_transaction_id', transactionId);
});

function isSupportedBrowser() {
  const browser = (new UAParser()).getBrowser().name;
  return browser === 'Firefox' || browser === 'Chrome';
}

async function getTileInfo(token) {
  const authQuery = new URLSearchParams();
  if (token !== null) {
    authQuery.append('token', token);
  }
  const authUrl = new URL('/generate-signed-url', authHost);
  authUrl.search = authQuery.toString();

  const response = await fetch(authUrl.toString(), {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'X-Transaction-ID': transactionId,
    },
  });
  if (!response.ok) {
    throw new Error('Response not ok');
  }

  return response.json();
}

async function main() {
  if (!isSupportedBrowser()) {
    document.getElementById('loading-spinner').style.display = 'none';
    document.getElementById('error-message').style.display = 'block';
    document.getElementById('error-message').innerHTML = 'You are using an unsupported browser, try Chrome or Firefox for best results.';
    return;
  }

  const currentUrl = new URL(window.location.href);
  const currentQuery = currentUrl.searchParams;

  let tileInfo;

  try {
    const transaction = Sentry.startTransaction({ name: 'viewer-bootstrap' });
    const span = transaction.startChild({ op: 'getTileInfo' });

    tileInfo = await getTileInfo(
      currentQuery.get('token'),
    );

    span.finish();
    transaction.finish();
  } catch (e) {
    document.getElementById('loading-spinner').style.display = 'none';
    document.getElementById('error-message').style.display = 'block';
    document.getElementById('error-message').innerHTML = 'Slide failed to load, an error has been reported.';
    throw e;
  }

  document.getElementById('loading-spinner').style.display = 'none';

  createMap(
    document.getElementsByClassName('map')[0],
    tileInfo.template_url,
    tileInfo.tile_levels,
    tileInfo.rotation,
    tileInfo.x_min
      ? [tileInfo.x_min, tileInfo.y_min, tileInfo.x_max, tileInfo.y_max]
      : undefined,
  );
}

main();
